import { mapState } from 'vuex';
export default {
	computed: {
		...mapState(['activeCalls']),
		isActive: function(){
			return this.associatedAction ? this.activeCalls.indexOf(this.associatedAction) > - 1 : false;
		}
	}
}